/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum APIContractStatusEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7,
    NUMBER_8 = 8,
    NUMBER_9 = 9
}


export function instanceOfAPIContractStatusEnum(value: any): boolean {
    for (const key in APIContractStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(APIContractStatusEnum, key)) {
            if (APIContractStatusEnum[key as keyof typeof APIContractStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function APIContractStatusEnumFromJSON(json: any): APIContractStatusEnum {
    return APIContractStatusEnumFromJSONTyped(json, false);
}

export function APIContractStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContractStatusEnum {
    return json as APIContractStatusEnum;
}

export function APIContractStatusEnumToJSON(value?: APIContractStatusEnum | null): any {
    return value as any;
}

